module.exports = __webpack_public_path__ + "img/rectangularTrapezoidVertical.ca31837c.svg";